import { Record, Map, fromJS } from "immutable";
import { ProductOptionGroupRecord, IProductOptionGroupData } from "common/records/ProductOptionGroup";
import { ProductRecord, IProductData } from "common/records/Product";
import { Nullable } from "common/records";

export const productToOptionGroupLinkFromJSON = (json: Partial<IProductToOptionGroupLinkData>) => {
  const recordData: IProductToOptionGroupLinkRecord = { ...(json as any) };

  if (json.options) {
    recordData.options = fromJS(json.options);
  }

  return new ProductToOptionGroupLinkRecord(recordData);
};

export interface IProductToOptionGroupLinkData {
  id: number;
  option_group_id: number;
  group: IProductOptionGroupData;
  product_id: number;
  product: IProductData;
  options: any;
  required_option_group: boolean;
}

export interface IProductToOptionGroupLinkRecord {
  id: number;
  option_group_id: number;
  group: Nullable<ProductOptionGroupRecord>;
  product_id: number;
  product: Nullable<ProductRecord>;
  options: any;
  required_option_group: boolean;
}

const defaultProductToOptionGroupLinkProps: IProductToOptionGroupLinkRecord = {
  id: 0,
  option_group_id: 0,
  group: null,
  product_id: 0,
  product: null,
  options: Map(),
  required_option_group: false,
};

export class ProductToOptionGroupLinkRecord
  extends Record(defaultProductToOptionGroupLinkProps)
  implements IProductToOptionGroupLinkRecord {}
